import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const DocumentRemovedIcon = (props: SvgIconT.Props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <g transform="translate(2 3)">
      <path d="M17 5h-2.798C13.54 5 13 4.46 13 3.798V1h1v2.798c0 .111.09.202.202.202H17v1Zm-7 4.5a4.5 4.5 0 1 1-9 0 4.5 4.5 0 0 1 9 0m1 0C11 6.467 8.533 4 5.5 4A5.506 5.506 0 0 0 0 9.5C0 12.533 2.467 15 5.5 15S11 12.533 11 9.5Z" />
      <path d="m1.964 12.328 6.718-6.717.707.707-6.717 6.717z" />
      <path d="m1.61 6.318.708-.707 6.717 6.717-.707.708z" />
      <path d="m17.707 3.693-3.4-3.4A1 1 0 0 0 13.6 0H4a1 1 0 0 0-1 1v1.5h1V1h9.6L17 4.4V18H4v-1.5H3V18a1 1 0 0 0 1 1h13a1 1 0 0 0 1-1V4.4a1 1 0 0 0-.293-.707Z" />
      <circle cx={3.5} cy={2.5} r={1} />
      <circle cx={3.5} cy={16.5} r={1} />
    </g>
  </SvgIcon>
);

export default DocumentRemovedIcon;
